import snakecaseKeys from 'snakecase-keys';
import { InjectivePermissionsV1Beta1Tx, InjectivePermissionsV1Beta1Params, } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
/**
 * @category Messages
 */
export default class MsgUpdateParams extends MsgBase {
    static fromJSON(params) {
        return new MsgUpdateParams(params);
    }
    toProto() {
        const { params } = this;
        const message = InjectivePermissionsV1Beta1Tx.MsgUpdateParams.create();
        message.authority = params.authority;
        message.params = params.params;
        const messageParams = InjectivePermissionsV1Beta1Params.Params.create();
        messageParams.wasmHookQueryMaxGas = params.params.wasmHookQueryMaxGas;
        message.params = messageParams;
        return InjectivePermissionsV1Beta1Tx.MsgUpdateParams.fromPartial(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/injective.permissions.v1beta1.MsgUpdateParams',
            ...proto,
        };
    }
    toAmino() {
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
        };
        return {
            type: 'permissions/MsgUpdateParams',
            value: message,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/injective.permissions.v1beta1.MsgUpdateParams',
            ...value,
        };
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/injective.permissions.v1beta1.MsgUpdateParams',
            message: proto,
        };
    }
    toBinary() {
        return InjectivePermissionsV1Beta1Tx.MsgUpdateParams.encode(this.toProto()).finish();
    }
}
